import { hasParentWithMatchingSelector } from 'utils/has-parent-with-matching-selector';

export const isRelatedEl = (el: HTMLElement): boolean => {
  // Not the best way to allow some outside click.
  // but the missing edge cases are very rare.
  return (
    hasParentWithMatchingSelector(el, '.ant-dropdown') ||
    hasParentWithMatchingSelector(el, '.ant-picker-dropdown') ||
    hasParentWithMatchingSelector(el, '.ant-popover')
  );
};
